import {cs} from "@common/react/chain-services";
import * as React from "react";
import {DialogService} from "../../../../common/dialog/dialog-service";
import "./leave-add-theme-dialog.scss";
import {Button} from "../../../../../../../common/form/buttons/button/button";
import {VerbScrollbar} from "@common/ui-components/verb-scrollbar/verb-scrollbar";

export const LeaveAddThemeDialog = ({next: rootNext}) =>
    cs(
        [
            "modal",
            ({}, next) =>
                DialogService({
                    render: ({resolve}) => ({
                        title: "Save changes?",
                        content: next({
                            resolve,
                        }),
                    }),
                    next: rootNext,
                }),
        ],
        ({modal}) => (
            <div className="leave-add-theme-dialog-8sx">
                <VerbScrollbar maxHeight="calc(100vh - 100px - 56px - 56px)" className="dialog-body">
                    <div className="messages">
                        <div className="message">You haven't saved your new theme.</div>

                        <div className="message">Do you want to save it or discard?</div>
                    </div>
                </VerbScrollbar>

                <div className="buttons">
                    <Button onClick={() => modal.resolve("save")}>Save New Theme</Button>
                    <Button btnType="secondary" onClick={() => modal.resolve("discard")}>
                        Discard
                    </Button>
                </div>
            </div>
        )
    );
